import { api, admin } from '@/utils/http'
import { query } from '@/utils'

const user = JSON.parse(localStorage.getItem('userinfo') || '{"uid": 0}')

export default {
  state: {
    user: user,
    serverCheck: false,
  },
  actions: {
    isLogin() {
      if (this.serverCheck && this.user.uid != 0) {
        return true
      }
      if (this.serverCheck && !this.user.uid) {
        return false
      }
      return admin.get('/auth/check').then(user => {
        this.serverCheck = true
        this.user = user


        // localStorage.setItem('userinfo', JSON.stringify(user))
        this.$rootVM && this.$rootVM.$acl.change(user.roleID)
        // setTimeout(() => {
        //   if (user.loginRole == 1) {
        //     this.$root.mainLayoutType = 'vertical'
        //     this.$root.themePrimaryColor = '#ea5455'
        //     this.$rootVM.$vs.theme({ primary: '#ea5455' });
        //   } else {
        //     this.$root.mainLayoutType = 'horizontal'
        //     this.$root.themePrimaryColor = '#28c76f'
        //     this.$rootVM.$vs.theme({ primary: '#28c76f' })
        //   }
        // }, 1);
        return true
      }).catch(() => {
        this.serverCheck = true
        localStorage.removeItem('userinfo')
        this.$rootVM && this.$rootVM.$acl.clear()
        return false
      })
    },
    // 该用户是不是渠道商
    isChannel(user) {
      return user.roleID == 3 || user.roleID == 4
    },
    // 渠道商过期没
    isChannelOutofdate(user) {
      if (user.roleID !== 3) {
        return false
      }
      const expireDate = new Date(user.channelExpire)
      return Date.now() > expireDate.getTime()
    },
    async logout() {
      const isLogin = await this.isLogin
      if (!isLogin) {
        throw new Error('您未登录')
      }
      return admin.post('/auth/logout').then(res => {
        this.user = {uid: 0}
        this.serverCheck = false
        this.$rootVM && this.$rootVM.$acl.clear()
        return res
      })

    },

    async loginSuccess(user, vm) {
      if (user && this.user.uid == 0) {
        this.user = user
        this.serverCheck = true
      }
      if (vm) {
        await this.$root.initRule(vm.$acl)
        // await this.$root.fetchDict()
        // vm.$acl.change(this.user.loginRole == 1 ? 'admin' : 'user')
        // setTimeout(() => {
        //   if (this.user.loginRole == 1) {
        //     this.$root.mainLayoutType = 'vertical'
        //     this.$root.themePrimaryColor = '#ea5455'
        //     this.$rootVM.$vs.theme({ primary: '#ea5455' });
        //   } else {
        //     this.$root.mainLayoutType = 'horizontal'
        //     this.$root.themePrimaryColor = '#28c76f'
        //     this.$rootVM.$vs.theme({ primary: '#28c76f' })
        //   }
        // }, 1);
        vm.$router.push('/guide')
      }
    },
    loginLocal(data) {
      return admin.post('/auth/local', data)
    },
    loginSms(data) {
      return api.post('/auth/sms', data)
    },
    createVerifyCode(data) {
      return api.post("/verifycode/create", data)
    },
    verifyCode(data) {
      return api.post("/verifycode/verify", data)
    },
    resetPassword(data) {
      return api.post('/auth/reset/passwd', data)
    },
    async register(data) {
      const user = await api.post('/auth/register', data)

      return user

    }
  }
}